<ed-loader [edLoaderConfig]="edLoaderConfig"></ed-loader>